/** Badge — shadcn Badge 어댑터. 기존 color prop 유지. */
import { ReactNode } from 'react'
import { Badge as ShadBadge } from '@/components/ui/badge'
import { cn } from './cn'

interface BadgeProps {
  color?: 'gray' | 'blue' | 'green' | 'red' | 'yellow'
  className?: string
  children: ReactNode
}

const COLOR_CLASS = {
  gray: 'bg-neutral-100 text-neutral-700 border-transparent',
  blue: 'bg-violet-100 text-violet-700 border-transparent',
  green: 'bg-green-100 text-green-700 border-transparent',
  red: 'bg-red-100 text-red-700 border-transparent',
  yellow: 'bg-amber-100 text-amber-700 border-transparent',
} as const

export function Badge({ color = 'gray', className, children }: BadgeProps) {
  return (
    <ShadBadge variant="secondary" className={cn(COLOR_CLASS[color], className)}>
      {children}
    </ShadBadge>
  )
}
